/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';

export default function SocialConnectModule(Component) {

    class SocialConnectModule extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                isDuplicateSocialModalVisible: false,
                isBlacklistModalVisible: false,
                isClientSocialModalVisible: false
            };

            this.remoteReturnHandler = this.remoteReturnHandler.bind(this);
            this.showDuplicateSocialModal = this.showDuplicateSocialModal.bind(this);
            this.showBlacklistModal = this.showBlacklistModal.bind(this);
            this.showClientSocialModal = this.showClientSocialModal.bind(this);

        }

        remoteReturnHandler(methodCallbacks) {

            if (_.isArray(methodCallbacks)) {
                methodCallbacks.map((mc) => {
                    // a little validation before we proceed
                    if (mc.path === undefined || mc.method === undefined || mc.method === '') {
                        return;
                    }

                    if (this.props.authState.credID.match(mc.method)) {
                        if (mc.callback !== undefined) {
                            this.props.authReturnHandler({
                                path: mc.path
                            }, mc.callback);
                        }
                    }

                });
            }

        }

        showDuplicateSocialModal(social, callbacks) {

            let confirmAction = () => {
                    let constants = this.props.app.config.constants,
                        loginTypes = [constants.POST_SVC_BLUESKY];

                    social.force = true;
                    if ((social.credID === undefined || !social.credID) && loginTypes.indexOf(social.psID) === -1) {
                        this.props.updateSocial(social);
                    } else {
                        if ((social.credID !== undefined && _.isString(social.credID) && social.credID.match("REAUTH")) || (loginTypes.indexOf(social.psID) !== -1 && social.action === "UPDATE")) {
                            this.props.updateSocial(social);
                        } else {
                            // be sure to make the social active if it's not in the create case
                            if (social.activeFlag !== undefined && social.activeFlag === 0) {
                                social.activeFlag = 1;
                            }
                            this.props.createSocial(social);
                        }
                    }

    				this.props.closeAllModals();

                    this.setState({
                        isDuplicateSocialModalVisible: false
                    }, () => {
                        if (callbacks.confirm) {
                            callbacks.confirm.apply(this, [social]);
                        }
                    });
    			},
    			modal = (
    				<ConfirmModal
    					{...this.props}
    					modalCopy="Someone is already using this social. Adding it here will deactivate it in all other dlvr.it accounts."
    					cancelAction={() => {
    						this.props.closeAllModals();
                            this.setState({
                                isDuplicateSocialModalVisible: false
                            }, () => {
                                if (callbacks.cancel) {
                                    callbacks.cancel.apply(this, [social]);
                                }
                            });
    					}}
    					confirmAction={confirmAction}
    					cancelLabel="Cancel"
    					confirmLabel="Continue"
    					context="duplicateSocial" />
    			);

    		this.props.closeOtherModals(modal);

            this.setState({
                isDuplicateSocialModalVisible: true
            });

        }

        showBlacklistModal(callbacks) {
            // special case error for people who's socials have been blacklisted
            let callback = () => {
                this.setState({
                    isBlacklistModalVisible: false
                });
                this.props.closeAllModals();

                if (callbacks.confirm) {
                    callbacks.confirm.apply(this, []);
                }
            };

            let modal = (
                <ConfirmModal
                    modalCopy={"This social profile has been suspended. dlvr.it will not connect or post to this profile."}
                    confirmLabel="OK"
                    confirmAction={callback}
                    closeAction={callback}
                    showCancel={false}/>
            );

            this.props.closeOtherModals(modal);

            this.setState({
                isBlacklistModalVisible: true
            });

        }

        showClientSocialModal(callbacks) {
            let organization = "The parent account";

            if (this.props.user.detail.clientInfo !== undefined && this.props.user.detail.clientInfo.organization) {
                organization = this.props.user.detail.clientInfo.organization;
            }

            let modal = (
                <ConfirmModal
                    modalCopy={`${organization} has reached the maximum number of social profiles for this account. Please contact ${organization} to resolve this issue.`}
                    confirmLabel="OK"
                    confirmAction={() => {
                        this.props.closeAllModals();
                        if (callbacks.confirm) {
                            callbacks.confirm.apply(this, []);
                        }
                    }}
                    showCancel={false}
                    showProcessing={false}/>
            );
            this.props.closeOtherModals(modal);

            this.setState({
                isClientSocialModalVisible: true
            });
        }


        render() {
            return (
                <Component
                    remoteReturnHandler={this.remoteReturnHandler}
                    showDuplicateSocialModal={this.showDuplicateSocialModal}
                    showBlacklistModal={this.showBlacklistModal}
                    showClientSocialModal={this.showClientSocialModal}
                    isDuplicateSocialModalVisible={this.state.isDuplicateSocialModalVisible}
                    isBlacklistModalVisible={this.state.isBlacklistModalVisible}
                    isClientSocialModalVisible={this.state.isClientSocialModalVisible}
                    {...this.props}/>
            );
        }
    }

    SocialConnectModule.displayName = "SocialConnectModule";
    return SocialConnectModule;
}
